var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{staticClass:"flex-basis-grow",attrs:{"placeholder":"Search by First Name, Last Name, Email","clearable":""},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})}
var staticRenderFns = []

export { render, staticRenderFns }